import React, { Component } from "react";
import { Switch } from "react-router";
import { TrainLayout } from "./TrainLayout";
import { RouteWithLayout } from "./RouteWithLayout";
import { TrainCustomerServicePage } from "../pages/train-customer-service/TrainCustomerServicePage";

export class TrainCustomerServiceSwitch extends Component {
  render() {
    return (
      <Switch>
        <RouteWithLayout layout={TrainLayout} exact path="/" component={TrainCustomerServicePage} />
      </Switch>
    );
  }
}
